import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-error_red",
  "use": "icon-error_red-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-error_red\"><path d=\"M916.041143 0L1024 107.958857 619.885714 512 1024 916.041143 916.041143 1024 512 619.885714 107.958857 1024 0 916.041143 404.041143 512 0 107.958857 107.958857 0 512 404.041143 916.041143 0z\" p-id=\"4951\" fill=\"#d81e06\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol